import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store.js'

import Buefy from 'buefy'
import './assets/styles/buefy.css'
import './assets/styles/reefmap.css'
import './assets/styles/mapbox.css'

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, signInAnonymously } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

export const data_url_new = "https://dataapi.coralgardeners.org"

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDByYxdnctmqQdd3VtjBV4NMAPe7O5_f64",
  authDomain: "cg-reefmap.firebaseapp.com",
  projectId: "cg-reefmap",
  storageBucket: "cg-reefmap.appspot.com",
  messagingSenderId: "761959520605",
  appId: "1:761959520605:web:d28c911b8a9d066aec30b4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth();
export const db = getFirestore(app);

const firebaseConfig_RestorationApp = {
  apiKey: "AIzaSyBc3QUNddqjuuDhu6CHqV6kIq2ALQWaHMk",
  authDomain: "restoration-ios.firebaseapp.com",
  projectId: "restoration-ios",
  storageBucket: "restoration-ios.appspot.com",
  messagingSenderId: "96749053095",
  appId: "1:96749053095:web:1c5163ac423f7e1185e782",
  measurementId: "G-R02354DHWZ"
};

const app_RestorationApp = initializeApp(firebaseConfig_RestorationApp, "resto");
// export const db_RestorationApp = getFirestore(app_RestorationApp)
export const db_resto_new = getFirestore(app_RestorationApp, "reefapp");
const auth_RestorationApp = getAuth(app_RestorationApp);

// Both Firestore reads this app makes (cg-reefmap's `db`, restoration-ios's
// `db_resto_new`) require request.auth != null, so both apps need their own
// anonymous sign-in -- getAuth() only ever authenticates the default app,
// it does not cover a second named app instance. Exported and awaited by
// callers (Map.vue) before any Firestore read fires, instead of the previous
// fire-and-forget signInAnonymously(auth) with no second call at all for the
// restoration-ios app -- that left every read against it permanently
// unauthenticated. Promise.allSettled so one project's sign-in failing
// doesn't hide whether the other succeeded.
export const authReady = Promise.allSettled([
	signInAnonymously(auth),
	signInAnonymously(auth_RestorationApp),
]).then(([cgResult, restoResult]) => {
	if (cgResult.status === 'rejected') {
		console.error('cg-reefmap anonymous sign-in failed:', cgResult.reason);
	}
	if (restoResult.status === 'rejected') {
		console.error('restoration-ios anonymous sign-in failed:', restoResult.reason);
	}
	return {
		cgOk: cgResult.status === 'fulfilled',
		restoOk: restoResult.status === 'fulfilled',
	};
});

// get coral gardeners org id
export const getCGOrgId = async () => {
    const response = await fetch(data_url_new + '/data/orgbyname?orgname=Coral%20Gardeners&pwd=showmethedata');
    const responseData = await response.json();
    return responseData.orgid;
};

Vue.config.productionTip = false

Vue.use(Buefy)

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
